import { render, staticRenderFns } from "./importerAddress.vue?vue&type=template&id=3e7957d0&scoped=true&"
import script from "./importerAddress.vue?vue&type=script&lang=js&"
export * from "./importerAddress.vue?vue&type=script&lang=js&"
import style0 from "./importerAddress.vue?vue&type=style&index=0&id=3e7957d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7957d0",
  null
  
)

export default component.exports